import { useQuery } from "./useQuery";
export const useSearchParam = (searchParam) => {
    const search = useQuery();
    const searchedKeyValue = search.get(searchParam);
    return searchedKeyValue;
};
